<template>
    <BaseDialog 
        max_width="50%"
        :dialog="dialog"
        title="Selezione zavorra"
        v-on:close_dialog="closeDialog"
    >
        <v-form v-model="valid">
            <div class="d-flex flex-column" v-if="checkZavorra">
                <span class="headline">Totale masse campione selezionate: {{data.totalMass | formatNumber}}{{data.uom}}</span><br/>
                <span class="headline">Portata massima strumento: {{data.maxRange | formatNumber}}{{data.uom}}</span><br/>
                <span class="headline" v-if="data.commonData && data.commonData.result">Test zavorra superato ad almeno: {{data.commonData.capacity * data.maxRange  | formatNumber}}</span>
                <NumericField dense outlined
                    v-model="weightSelected"
                    :class="checkWeight(data.totalMass, weightSelected)"
                    required
                    label="Inserisci valore della zavorra"
                    placeholder="0"
                    :rules="[rules.mandatory]"
                    :suffix="data.uom"
                ></NumericField>
                <v-alert type="warning" :value="true" v-if="validity && valid">
                    Quantità di masse selezionate insufficienti!
                </v-alert>
            </div>
            <div class="d-flex" v-else>
                <v-alert type="error" :value="true">
                    Test zavorra non superato!
                </v-alert>
            </div>
        </v-form>
        <template v-slot:action>
            <div class="d-flex align-center justify-center my-4">
                <v-btn color="primary" :disabled="validity || computedWeight" @click="save">Salva</v-btn>
                <v-btn text class="ml-2" @click="closeDialog">Annulla</v-btn>
            </div>
        </template>
    </BaseDialog>
</template>
<script>
import {f_rules} from '../../utils/commonUtils'
import BaseDialog from '../dialogs/BaseDialog'
import Big from "big.js"
// // import _ from 'lodash'

export default {
    components: {BaseDialog},
    props: ['data'],
    data() {
        return {
            weightSelected: 0,
            rules: f_rules,
            valid: false,
            dialog: false,
            minRange: 0
        }
    },
    computed: {
        validity(){
            if(this.valid && this.data.totalMass && this.data.maxRange){
                let m = 0 
                if(Big(this.data.totalMass).gte(Big(this.data.maxRange).times(0.5))){
                    m = Big(this.data.maxRange).times(0.2)
                } else if(this.data.commonData && this.data.commonData.capacity) {
                    m = Big(this.data.maxRange).times(this.data.commonData.capacity)
                } else {
                    return true
                }
                if(this.weightSelected){
                    let compare = m.gt(this.weightSelected)
                    return compare
                }
            }
            return true
        },
        checkZavorra(){
            if(Big(this.data.totalMass).gte(Big(this.data.maxRange).times(0.5))){
                return true
            } else if (this.data.commonData) {
                return this.data.commonData.result
            } else {
                return false
            }
        },
        computedWeight(){
            return Big(this.data.totalMass).lt(this.weightSelected)
        }
    },
    methods: {
        checkWeight(total, current){
            // console.log("total and current", total, current)
            if(total && current){
                if( Big(total).lt(current)){
                    return 'error_field'
                } 
            }
        },
        closeDialog(){
            this.dialog = false
        },
        save(){
            this.$emit('changedWeight', this.weightSelected)
            this.closeDialog()
        },
        setOldWeight(oldWeight){
            this.weightSelected = _.cloneDeep(oldWeight)
        }
    },
}
</script>